import { render, staticRenderFns } from "./FundDetail.vue?vue&type=template&id=311c7932&"
import script from "./FundDetail.vue?vue&type=script&lang=js&"
export * from "./FundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports